import { Criterion } from '@/interfaces/criterion';
import { CriterionResource, criterionResource } from '@/resources/criterion.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł
 *
 * @export
 * @class CriterionModule
 * @extends {EntityModule<Criterion, CriterionResource>}
 */
export class CriterionModule extends EntityModule<Criterion, CriterionResource> {
  constructor() {
    super(criterionResource);
  }
}

export default new CriterionModule();
